import { render } from "./WebcamCapture.vue?vue&type=template&id=4b726d47&scoped=true"
import script from "./WebcamCapture.vue?vue&type=script&lang=js"
export * from "./WebcamCapture.vue?vue&type=script&lang=js"

import "./WebcamCapture.vue?vue&type=style&index=0&id=4b726d47&scoped=true&lang=css"
import "./WebcamCapture.vue?vue&type=style&index=1&id=4b726d47&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b726d47"]])

export default __exports__